import { useRef, useState } from 'react';
import { Slide } from '@core/swagger-client';
import { MinMax } from '@core/ui' 

import { useTranslation } from 'react-i18next';
interface NextSlidePreviewProps {
    slideToPreview: Slide;
}

export const NextSlidePreview = ({ slideToPreview }: NextSlidePreviewProps) => {
    const [isActive, setActive] = useState(true);
    const [animateClass, setAnimateClass] = useState('');
    const hasClicked = useRef(false);

    // Click handler to toggle the class
    const handleClick = () => {
        setActive(!isActive);
        if (!hasClicked.current) {
            hasClicked.current = true;
            setAnimateClass('animate-toMax');
        } else {
            setAnimateClass(prev =>
                prev === 'animate-toMax' ? 'animate-toMin' : 'animate-toMax'
            );
        }
    };

    const { t } = useTranslation();

    return (
        <div className={`relative ${isActive ? 'w-40 h-auto' : 'size-16'} justify-self-end bg-black/20 rounded-l-lg rounded-tr-lg text-white p-2 transition-[height,width] ease-in-out duration-200`}>
            <img
                src={`${slideToPreview.url}`}
                alt=""
                className="w-full h-full block mx-auto object-contain"
                data-testid="NextSlidePreviewImage"
            />
            <button onClick={handleClick} className="absolute top-2 bg-primary/80 hover:bg-primary rounded-md p-3 transition-colors ease-in-out duration-200">
                <span className="sr-only">{isActive ? t('Broadcaster.Button.NextSlideToggle.Min') : t('Broadcaster.Button.NextSlideToggle.Max')}</span>
                <MinMax classNames={`${animateClass}`} />
            </button>
        </div>
    );
};